import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  expand() {
    this.element.dataset.sidebarExpanded = "true"
  }

  toggle() {
    const expanded =
      this.element.dataset.sidebarExpanded == "true" ? "false" : "true"

    this.element.dataset.sidebarExpanded = expanded
    this._setCookie()
  }

  _setCookie() {
    const expanded = this.element.dataset.sidebarExpanded
    document.cookie = `sidebar_expanded=${expanded}; path=/`
  }
}
